"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var tableTranslate = {
  body: {
    emptyDataSourceMessage: "No hay registros para mostrar",
    addTooltip: "Agregar persona",
    deleteTooltip: "Eliminar",
    editTooltip: "Editar",
    filterRow: {
      filterTooltip: "Filtrar"
    },
    editRow: {
      deleteText: "Estas seguro de eliminar esta fila?",
      cancelTooltip: "Cancelar",
      saveTooltip: "Guardar"
    }
  },
  grouping: {
    placeholder: "Arrastrar encabezados..."
  },
  header: {
    actions: "Acciones"
  },
  pagination: {
    labelDisplayedRows: "{from}-{to} de {count}",
    labelRowsSelect: "filas",
    labelRowsPerPage: "Filas por Página:",
    firstAriaLabel: "Primera Página",
    firstTooltip: "Primera Página",
    previousAriaLabel: "Página Previa",
    previousTooltip: "Página Previa",
    nextAriaLabel: "Siguiente Página",
    nextTooltip: "Siguiente Página",
    lastAriaLabel: "Ultima Página",
    lastTooltip: "Ultima Página"
  },
  toolbar: {
    addRemoveColumns: "Agregar o remover columnas",
    nRowsSelected: "{0} fila(s) seleccionada(s)",
    showColumnsTitle: "Mostrar Columnas",
    showColumnsAriaLabel: "Mostrar Columnas",
    exportTitle: "Exportar",
    exportAriaLabel: "Exportar",
    exportName: "Exportar a CSV",
    searchTooltip: "Buscar",
    searchPlaceholder: "Buscar"
  }
};
var _default = tableTranslate;
exports.default = _default;